import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UserInputErrorService {
    public userInputErrorSignal$ = signal<{ uuid: string; report: any }>({ uuid: '', report: {} });

    public reset() {
        this.userInputErrorSignal$.set({ uuid: '', report: {} });
    }
}
